/* eslint-disable max-len */
const Disqulifiers = [
    {
       id: 'DEFAULT_0',
      title: 'Forgery of certificates, false marking of aircraft, and other aircraft registration violation, 49 U.S.C46306',
      label: 'Forgery of certificates, false marking of aircraft, and other aircraft registration violation, 49 U.S.C46306',
      stateKey: 'multipleRemarks',
      isDefault: true
    },
    {
       id: 'DEFAULT_1',
      title: 'Interference with air navigation, 49 U.S.C46308',
      label: 'Interference with air navigation, 49 U.S.C46308',
      stateKey: 'multipleRemarks',
      isDefault: true
    },
    {
       id: 'DEFAULT_2',
      title: 'Improper transportation of a hazardous material, 49 U.S.C46312',
      label: 'Improper transportation of a hazardous material, 49 U.S.C46312',
      stateKey: 'multipleRemarks',
      isDefault: true
    },
    {
       id: 'DEFAULT_3',
      title: 'Aircraft piracy, 49 U.S.C 46502',
      label: 'Aircraft piracy, 49 U.S.C 46502',
      stateKey: 'multipleRemarks',
      isDefault: true
    },
    {
       id: 'DEFAULT_4',
      title: 'Interference with flight crew members or flight attendants 49 U.S.C 46504',
      label: 'Interference with flight crew members or flight attendants 49 U.S.C 46504',
      stateKey: 'multipleRemarks',
      isDefault: true
    },
    {
       id: 'DEFAULT_5',
      title: 'Commission of certain crimes aboard aircraft in flight, 49 U.S.C 46506',
      label: 'Commission of certain crimes aboard aircraft in flight, 49 U.S.C 46506',
      stateKey: 'multipleRemarks',
      isDefault: true
    },
    {
       id: 'DEFAULT_6',
      title: 'Carrying a weapon or explosive aboard aircraft, 49 U.S.C46502',
      label: 'Carrying a weapon or explosive aboard aircraft, 49 U.S.C46502',
      stateKey: 'multipleRemarks',
      isDefault: true
    },
    {
       id: 'DEFAULT_7',
      title: 'Conveying false information and threats, 449 U.S.C46507',
      label: 'Conveying false information and threats, 449 U.S.C46507',
      stateKey: 'multipleRemarks',
      isDefault: true
    },
    {
       id: 'DEFAULT_8',
      title: 'Aircraft piracy outside the special aircraft jurisdiction of the United States, 49 U.S.C46502',
      label: 'Aircraft piracy outside the special aircraft jurisdiction of the United States, 49 U.S.C46502',
      stateKey: 'multipleRemarks',
      isDefault: true
    },
    {
       id: 'DEFAULT_9',
      title: 'Lighting violations involving transporting controlled substances 49 U.S.C46315',
      label: 'Lighting violations involving transporting controlled substances 49 U.S.C46315',
      stateKey: 'multipleRemarks',
      isDefault: true
    },
    {
       id: 'DEFAULT_10',
      title: 'Unlawful entry into an aircraft or airport area that serves air carriers or foreign air carriers contrary to established security requirements, 49 U.S.C46317',
      label: 'Unlawful entry into an aircraft or airport area that serves air carriers or foreign air carriers contrary to established security requirements, 49 U.S.C46317',
      stateKey: 'multipleRemarks',
      isDefault: true
    },
    {
       id: 'DEFAULT_11',
      title: 'Destruction of an aircraft or aircraft facility, 48 U.S.C 32',
      label: 'Destruction of an aircraft or aircraft facility, 48 U.S.C 32',
      stateKey: 'multipleRemarks',
      isDefault: true
    },
    {
       id: 'DEFAULT_12',
      title: 'Murder',
      label: 'Murder',
      stateKey: 'multipleRemarks',
      isDefault: true
    },
    {
       id: 'DEFAULT_13',
      title: 'Assault with intent to murder',
      label: 'Assault with intent to murder',
      stateKey: 'multipleRemarks',
      isDefault: true
    },
    {
       id: 'DEFAULT_14',
      title: 'Espionage',
      label: 'Espionage',
      stateKey: 'multipleRemarks',
      isDefault: true
    },
    {
       id: 'DEFAULT_15',
      title: 'Sedition',
      label: 'Sedition',
      stateKey: 'multipleRemarks',
      isDefault: true
    },
    {
       id: 'DEFAULT_17',
      title: 'Kidnapping or hostage taking',
      label: 'Kidnapping or hostage taking',
      stateKey: 'multipleRemarks',
      isDefault: true
    },
    {
       id: 'DEFAULT_18',
      title: 'Treason',
      label: 'Treason',
      stateKey: 'multipleRemarks',
      isDefault: true
    },
    {
       id: 'DEFAULT_19',
      title: 'Rape or aggravated sexual abuse',
      label: 'Rape or aggravated sexual abuse',
      stateKey: 'multipleRemarks',
      isDefault: true
    },
    {
       id: 'DEFAULT_20',
      title: 'Unlawful possession, use, sale, distribution, or manufacture of an explosive or weapon',
      label: 'Unlawful possession, use, sale, distribution, or manufacture of an explosive or weapon',
      stateKey: 'multipleRemarks',
      isDefault: true
    },
    {
      id: 'DEFAULT_21',
      title: 'Extortion',
      label: 'Extortion',
      stateKey: 'multipleRemarks',
      isDefault: true
    },
    {
      id: 'DEFAULT_22',
      title: 'Armed or felony unarmed robbery',
      label: 'Armed or felony unarmed robbery',
      stateKey: 'multipleRemarks',
      isDefault: true
    },
    {
      id: 'DEFAULT_22',
      title: 'Distribution, of, or intent to distribute, a controlled substance',
      label: 'Distribution, of, or intent to distribute, a controlled substance',
      stateKey: 'multipleRemarks',
      isDefault: true
    },
    {
      id: 'DEFAULT_23',
      title: 'Felony arson',
      label: 'Felony arson',
      stateKey: 'multipleRemarks',
      isDefault: true
    },
    {
      id: 'DEFAULT_24',
      title: 'Felony involving a threat',
      label: 'Felony involving a threat',
      stateKey: 'multipleRemarks',
      isDefault: true,
      sub: [
        {
          id: 'SUB24_0',
          title: 'Willful destruction of property',
          label: 'Willful destruction of property',
          stateKey: 'felonyInvolvingRemarks',
          isDefault: true
        },
        {
          id: 'SUB24_1',
          title: 'Importation or manufacture of a controlled substance',
          label: 'Importation or manufacture of a controlled substance',
          stateKey: 'felonyInvolvingRemarks',
          isDefault: true
        },
        {
          id: 'SUB24_2',
          title: 'Burglary',
          label: 'Burglary',
          stateKey: 'felonyInvolvingRemarks',
          isDefault: true
        },
        {
          id: 'SUB24_3',
          title: 'Theft',
          label: 'Theft',
          stateKey: 'felonyInvolvingRemarks',
          isDefault: true
        },
        {
          id: 'SUB24_4',
          title: 'Dishonesty, fraud, or misrepresentation',
          label: 'Dishonesty, fraud, or misrepresentation',
          stateKey: 'felonyInvolvingRemarks',
          isDefault: true
        },
        {
          id: 'SUB24_5',
          title: 'Possession or distribution of stolen property',
          label: 'Possession or distribution of stolen property',
          stateKey: 'felonyInvolvingRemarks',
          isDefault: true
        },
        {
          id: 'SUB24_6',
          title: 'Aggravated assault',
          label: 'Aggravated assault',
          stateKey: 'felonyInvolvingRemarks',
          isDefault: true
        },
        {
          id: 'SUB24_7',
          title: 'Bribery',
          label: 'Bribery',
          stateKey: 'felonyInvolvingRemarks',
          isDefault: true
        },
        {
          id: 'SUB24_8',
          title: 'Illegal possession of a controlled substance punishable by a maximum term of imprisonment of more than 1 year',
          label: 'Illegal possession of a controlled substance punishable by a maximum term of imprisonment of more than 1 year',
          stateKey: 'felonyInvolvingRemarks',
          isDefault: true
        }
      ]
    },
    {
      id: 'DEFAULT_25',
      title: 'Violence at international airports, 18 U.S.C 33',
      label: 'Violence at international airports, 18 U.S.C 337',
      stateKey: 'multipleRemarks',
      isDefault: true
    },
    {
      id: 'DEFAULT_25',
      title: 'Conspiracy or attempt to commit acts listed in this paragraph (d)',
      label: 'Conspiracy or attempt to commit acts listed in this paragraph (d)',
      stateKey: 'multipleRemarks',
      isDefault: true
    }
  ];

export default Disqulifiers;
